import { SelectItem } from "primeng/api";
import { PaginationParams, DataElement, Doctor } from "./common";
import { Clinic } from "./clinic.model";

export class UiUser implements SelectItem {
  username: string;
  userId: number;
  userDescr: string;
  clinic: Clinic;
  clinicDescr: string;
  doctor: Doctor;
  plant: DataElement;
  role: UserRole;
  roleCode: string;
  roleDescr: string;
  phone: string;
  password: string;
  activeSw: boolean = true;
  cognitoStatusSw: boolean;
  lastSeen: string;
  lang: string;
  org: string;
  areaCode: string = "972";
  authDetails: AuthDetails = new AuthDetails();
  token: number;
  permittedClinicList: DataElement[] = [];
  agentCode: number;
  allowCreateOrderSw: boolean;

  // cognito params
  firstName: string;
  lastName: string;
  accessJwtToken: string;
  idJwtToken: string;
  refreshToken: string;
  refreshTokenObject: any;
  isLoggedIn: boolean = false;
  cognitoUserObject: any;

  constructor(id: number = undefined, text: string = undefined) {
    this.userId = id;
    this.userDescr = text;
    this.isLoggedIn = true;
  }

  get isNewUser(): boolean {
    return !this.userId;
  }

  get isLabUser(): boolean {
    return this.org == "LAB";
  }

  get isPlantUser(): boolean {
    return this.org == "PLANT";
  }

  get isClinicUser(): boolean {
    return this.org == "CLINIC";
  }

  get isMultiClinicUser(): boolean {
    return this.permittedClinicList &&
      this.permittedClinicList.length >= 2;
  }

  get label(): string {
    return this.userDescr;
  }

  get value() {
    return this;
  }
}

export class AuthDetails {
  constructor() {}

  getStringValue(key: string): string {
    let value = this[key];
    return value ? value : "";
  }

  getBooleanValue(key: string): boolean {
    let value = this[key] as String;
    if (!value) return false;
    return !!value;
  }

  setValue(key: string, value: string) {
    this[key] = value;
  }
}

export class UsersSearchParams extends PaginationParams {
  username?: string;
  clinic?: DataElement;
  plant?: DataElement;
  role?: DataElement;
  org?: string;
  taskUsersSw?: boolean;
  generalTasksSw?: boolean;
  fromUserEditSw?: boolean = false;
  constructor() {
    super();
  }
}

export class UserRole extends DataElement {
  org: string;

  constructor(id: string, text: string, org: string) {
    super(id, text);
    this.org = org;
  }
}
